import { createButton } from '@archer-technologies/ui-components';
import { createElement, Component } from 'react';
import { Plugin, Template, TemplatePlaceholder } from '@devexpress/dx-react-core';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var pluginDependencies = [{
  name: 'Toolbar'
}];

var ToolbarAddNew = /*#__PURE__*/function (_React$Component) {
  _inherits(ToolbarAddNew, _React$Component);

  var _super = _createSuper(ToolbarAddNew);

  function ToolbarAddNew() {
    _classCallCheck(this, ToolbarAddNew);

    return _super.apply(this, arguments);
  }

  _createClass(ToolbarAddNew, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          disabled = _this$props.disabled,
          translate = _this$props.translate;
      return /*#__PURE__*/createElement(Plugin, {
        name: "toolbarAddNewFilter",
        dependencies: pluginDependencies
      }, /*#__PURE__*/createElement(Template, {
        name: "toolbarContent"
      }, /*#__PURE__*/createElement(TemplatePlaceholder, null), createButton({
        type: 'ADD_NEW',
        isIconButton: true,
        tooltipTitle: translate('rgrd:addNewButton'),
        actionType: 'primary',
        onClick: onClick,
        disabled: disabled,
        translate: translate
      })));
    }
  }]);

  return ToolbarAddNew;
}(Component);

export { ToolbarAddNew };